import { render, staticRenderFns } from "./scrolldown-quarternary.vue?vue&type=template&id=4974fc23&scoped=true&"
import script from "./scrolldown-quarternary.vue?vue&type=script&lang=js&"
export * from "./scrolldown-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4974fc23",
  null
  
)

export default component.exports